const NZ_TIME_ZONE = 'Pacific/Auckland';

export const formatMoney = (value: number, fractionDigits = 2): string =>
  `$${Math.abs(value).toLocaleString('en-NZ', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;

export const formatSignedMoney = (value: number): string =>
  `${value < 0 ? '−' : '+'}${formatMoney(value)}`;

export const formatShortDate = (value: string | Date): string =>
  new Date(value).toLocaleString('en-NZ', {
    timeZone: NZ_TIME_ZONE,
    day: 'numeric',
    month: 'short',
  });

export const formatDateTime = (value: string | Date): string =>
  new Date(value).toLocaleString('en-NZ', {
    timeZone: NZ_TIME_ZONE,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

// Parses user-entered amounts such as "-1,234.50" or "$800". Returns null if
// the input isn't a number.
export const parseAmount = (input: string): number | null => {
  const cleaned = input.replace(/[\s,$]/g, '').replace('−', '-');
  if (!/^-?\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  return Number(cleaned);
};
